export default __webpack_public_path__ + "static/media/digita-logo-black.0f391511.svg";